<template>
  <div class="add-child-wrapper">
    <div class="content-wrapper">
      <div class="up-title">
        <span class="title"> 家长信息 </span>
      </div>

      <div v-if="qrUserInfo" class="info">
        <img :src="qrUserInfo.headImageUrl" alt="" class="user-icon" />
        <div class="rg">
          <p class="nicname">昵称: {{ qrUserInfo.nickname }}</p>
          <p class="child-id">{{ qrUserInfo.exclusiveCode }}</p>
        </div>
      </div>

      <div class="xieyi-wrapper">
        <div
          style="
            display: flex;
            line-height: 20px;
            font-size: 11px;
            color: #999999;
            align-items: cneter;
          "
        >
          <div style="align-items: center; height: 100%; display: flex">
            <img
              style="width: 14px; height: 14px; margin-right: 5px"
              :src="require('../../assets/imgs/family/checkbox.png')"
            />
          </div>
          我已阅读并同意
          <span @click="action_bindDes" class="bind-des">《绑定说明》</span>
          ,并对由此产生的后果负责
        </div>
      </div>
      <div class="home-button" @click="this.action_addChild">
        {{ "确认关注家长" }}
      </div>

      <!-- <van-button class="learn-flow-btn" plain type="info" @click="action_addChild()">确认添加孩子</van-button> -->

      <van-popup v-model="show">
        <p class="bind-desc">
          {{
            "绑定说明：\n1、账号被绑定后，您的阅读信息将随时同步在绑定账号内。\n2、绑定账号需要家长操作输入学生的专属码，解除绑定同样也只能由家长进行操作，学生没有权限解除绑定。\n3、最终解释权归《蓝思原版分级阅读》所有。"
          }}
        </p>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { postBind } from "@/api/family";
import * as ActionTypes from "@/store/action-types";

export default {
  name: "ScanAddChild",
  data() {
    return {
      qrUserInfo: null, //扫码获取的用户信息
      show: false,
    };
  },

  activated() {
    this.qrUserInfo = JSON.parse(this.$route.params.qrcodeResult);
  },

  methods: {
    //=============action=============
    //确定添加孩子
    action_addChild() {
      this.$loading.show();
      let params = {
        roleType: 2,
        userId: this.qrUserInfo.userId,
      };
      postBind(params)
        .then((res) => {
          this.$loading.hide();
          this.$toast({
            message: "添加成功",
            duration: 1000,
          });
          this.$store.dispatch(ActionTypes.GET_USER_INFO).then(() => {
            this.$router.replace("/relationShip");
          });
        })
        .catch(() => {
          this.$loading.hide();
        });
    },

    //绑定说明
    action_bindDes() {
      this.show = true;
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.add-child-wrapper {
  background-color: #fcfcfc;
}

.content-wrapper {
  margin: 30px 20px;
  // border: 1px solid $common-line-color;
  text-align: center;
  border-radius: 6px;
  padding: 14px 10px;
}

.up-title {
  align-items: center;

  .title {
    font-size: 18px;
    font-weight: bold;
  }
}

.info {
  margin-top: 40px;
  // display: flex;
  align-items: center;

  // border: 1px solid $common-line-color;
  .user-icon {
    margin-right: 10px;
    width: 68px;
    height: 68px;
    border-radius: 34px;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.19);
    border: 2px solid #FFFFFF;
  }

  .nicname {
    margin-top: 20px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: bold;
  }

  .child-id {
    color: #999999;
  }
}

.xieyi-wrapper {
  margin-top: 20px;
  display: flex;

  .bind-des {
    color: $common-blue;
  }
}

.learn-flow-btn {
  margin-top: 30px;
  width: 100%;
  background-color: $common-blue;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
}

.bind-desc {
  background-color: #fff;
  border-radius: 10px;
  width: 260px;
  padding: 30px 20px;
  white-space: pre-line;
}

.home-button {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  margin-top: 10px;
  // width: 100%;
  border-radius: 22px;
  background: linear-gradient(right, #98CEFF, #3994E7);
}
</style>



// WEBPACK FOOTER //
// app/pages/family/ScanAddParent.vue